import { Layer } from 'ol/layer'
import BaseVectorLayer from 'ol/layer/BaseVector'
import { StyleLike } from 'ol/style/Style'
import { useEffect } from 'react'

import { useMap } from '../useMap'

type TUseLayerProps = {
  layer?: Layer
  style?: StyleLike
}

type TUseLayer = {
  layer?: Layer
}

export function useLayer({ layer, style }: TUseLayerProps): TUseLayer {
  const { map } = useMap()

  useEffect(() => {
    if (layer) {
      map.addLayer(layer)
    }
    return () => {
      if (layer) {
        map.removeLayer(layer)
      }
    }
  }, [layer])

  useEffect(() => {
    if (layer instanceof BaseVectorLayer) {
      layer.setStyle(style)
    }
  }, [layer, style])

  return { layer }
}

useLayer.whyDidYouRender = false
